import type { DataTableColumn } from "../ui/DataTable/types";

export const tableColumns: DataTableColumn[] = [
  { key: "title", label: "Title" },
  { key: "category", label: "Category" },
  { key: "location", label: "Location" },
  { key: "payment", label: "Compensation" },
];
